export default __webpack_public_path__ + "static/media/misc-books5-1024w.cf6c1ed8.webp";